import { get, URLs } from './request.js';

/**
 * Search Restaurants, results come in the form of a list of delivery_groups
 * @param {*} param0
 */
export const searchRestaurants = async ({ addressId, geoLocation, time = 'asap' }) => {
  if (!addressId && !geoLocation) {
    throw new Error('should at least specify addressId or geoLocation');
  }
  const query = addressId
    ? {
      time,
      address_id: addressId,
    }
    : {
      time,
      latitude: geoLocation.lat,
      longitude: geoLocation.lng,
    };

  const { data } = await get({
    url: `${URLs.monoproxy}/on_demand/v2/delivery_groups`,
    options: {
      API_BASE: 'thisServer',
    },
    data: {
      query,
    },
  });
  return data;
};

export const getSearchOnTerm = async ({ term, addressId, geoLocation }) => {
  let query = {
    search_term: term,
  };
  if (addressId) {
    query = {
      ...query,
      ...{
        address_id: addressId,
      },
    };
  } else if (geoLocation) {
    query = {
      ...query,
      ...{
        latitude: geoLocation.lat,
        longitude: geoLocation.lng,
      },
    };
  }
  const { data } = await get({
    url: `${URLs.api}/on_demand/v2/meal_instances/search`,
    data: {
      query,
    },
  });
  return data;
};

export const getRestaurantCollection = async () => {
  const { data } = await get({
    url: `${URLs.monoproxy}/v2/restaurant_collections`,
    options: {
      API_BASE: 'thisServer',
    },
  });
  return data;
};
